import turkishStrings from 'react-timeago/lib/language-strings/tr';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

export const formatter = buildFormatter(turkishStrings);